import React, { useEffect, useState } from 'react';
import { getWatchlist, removeFromWatchlist, getMyContacts, addToPortfolio, getPortfolio, sendContact } from '../../api';
import StartupCard from '../../components/StartupCard';
import { useToast } from '../../components/Toast';

function ContactModal({ startup, onClose, onSent }) {
  const toast = useToast();
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSend = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await sendContact({ startup_id: startup.id, message });
      setSent(true);
      setTimeout(() => { onSent(); onClose(); }, 1500);
    } catch (err) {
      toast.error(err.message);
    }
    setSending(false);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}
      onClick={onClose}>
      <div style={{ background: 'white', borderRadius: 12, padding: 28, maxWidth: 500, width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}
        onClick={e => e.stopPropagation()}>
        {sent ? (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✉️</div>
            <h3 style={{ color: '#27AE60', marginBottom: 8 }}>Message envoyé !</h3>
            <p style={{ color: 'var(--text-light)', fontSize: 14 }}>Votre demande de contact a été transmise à {startup.name}.</p>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0 }}>Contacter {startup.name}</h3>
              <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-light)' }}>✕</button>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label className="form-label">Votre message</label>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder={`Bonjour,\n\nJe souhaiterais en savoir plus sur ${startup.name} et échanger sur d'éventuelles opportunités de collaboration.\n\nCordialement`}
                className="form-input"
                style={{ minHeight: 140, resize: 'vertical', fontFamily: 'inherit', fontSize: 13 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={onClose} className="btn btn-outline" style={{ fontSize: 13 }}>Annuler</button>
              <button onClick={handleSend} className="btn btn-accent" disabled={sending || !message.trim()} style={{ fontSize: 13 }}>
                {sending ? 'Envoi...' : 'Envoyer la demande'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function WatchlistPage() {
  const toast = useToast();
  const [watchlist, setWatchlist] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [portfolioIds, setPortfolioIds] = useState(new Set());
  const [contactedIds, setContactedIds] = useState(new Set());
  const [tab, setTab] = useState('watchlist');
  const [addingToPortfolio, setAddingToPortfolio] = useState(null);
  const [contactStartup, setContactStartup] = useState(null); // startup for contact modal

  const load = () => {
    getWatchlist().then(setWatchlist).catch(console.error);
    getMyContacts().then(data => {
      setContacts(data);
      setContactedIds(new Set(data.map(c => c.startup_id)));
    }).catch(console.error);
    getPortfolio().then(data => {
      setPortfolioIds(new Set(data.map(p => p.id)));
    }).catch(console.error);
  };

  useEffect(() => { load(); }, []);

  const handleRemove = async (startupId) => {
    await removeFromWatchlist(startupId);
    load();
  };

  const handleAddToPortfolio = async (startupId) => {
    setAddingToPortfolio(startupId);
    try {
      await addToPortfolio({ startup_id: startupId, status: 'suivi' });
      setPortfolioIds(prev => new Set([...prev, startupId]));
    } catch (err) {
      toast.error(err.message);
    }
    setAddingToPortfolio(null);
  };

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: 24 }}>Mon Espace Investisseur</h1>

        <div style={{ display: 'flex', gap: 0, marginBottom: 32, borderBottom: '2px solid var(--border)' }}>
          {[
            { key: 'watchlist', label: `Favoris (${watchlist.length})` },
            { key: 'contacts', label: `Demandes envoyées (${contacts.length})` },
          ].map(t => (
            <button key={t.key} onClick={() => setTab(t.key)}
              style={{ padding: '12px 24px', border: 'none', background: 'none', cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 14, fontWeight: 600,
                borderBottom: `3px solid ${tab === t.key ? 'var(--primary-light)' : 'transparent'}`,
                color: tab === t.key ? 'var(--primary)' : 'var(--text-light)', marginBottom: -2 }}>
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'watchlist' && (
          watchlist.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-light)' }}>
              <p style={{ fontSize: 18, marginBottom: 8 }}>Votre watchlist est vide</p>
              <p>Ajoutez des startups en favoris depuis la page de recherche.</p>
            </div>
          ) : (
            <div className="grid-cards">
              {watchlist.map(s => {
                const isInPortfolio = portfolioIds.has(s.id);
                const isAdding = addingToPortfolio === s.id;
                const isContacted = contactedIds.has(s.id);
                return (
                  <div key={s.id} style={{
                    position: 'relative',
                    background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)',
                    transition: 'all 0.2s', overflow: 'hidden'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary-light)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(74,113,229,0.10)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
                  >
                    {/* Suspended indicator */}
                    {s.status === 'suspendu' && (
                      <div style={{ background: '#FFEBEE', color: '#C62828', padding: '8px 20px', fontSize: 12, fontWeight: 600, borderBottom: '1px solid #FFCDD2' }}>
                        🔒 Cette startup a été désactivée par l'administrateur
                      </div>
                    )}
                    {/* Card content area — clickable to navigate */}
                    <StartupCard startup={s} noBorder />
                    {/* Remove from favorites button */}
                    <button onClick={() => handleRemove(s.id)}
                      style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(0,0,0,0.5)', color: 'white',
                        border: 'none', borderRadius: '50%', width: 28, height: 28, cursor: 'pointer', fontSize: 14 }}>
                      ✕
                    </button>
                    {/* Action buttons — inside the card */}
                    <div style={{ padding: '0 20px 16px', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', marginTop: 0, paddingTop: 12 }}>
                      {s.status === 'suspendu' ? (
                        <div style={{ flex: 1, textAlign: 'center', fontSize: 11, color: '#C62828', fontWeight: 600, padding: '8px 0' }}>
                          Startup désactivée — actions indisponibles
                        </div>
                      ) : (
                        <>
                          {/* Portfolio button */}
                          {isInPortfolio ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#27AE60', fontWeight: 600, flex: 1 }}>
                              <span>✓</span> Dans le portefeuille
                            </div>
                          ) : (
                            <button
                              onClick={() => handleAddToPortfolio(s.id)}
                              disabled={isAdding}
                              style={{
                                flex: 1, padding: '8px 10px', fontSize: 11, fontWeight: 600,
                                background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%)',
                                color: 'white', border: 'none', borderRadius: 6, cursor: isAdding ? 'wait' : 'pointer',
                                opacity: isAdding ? 0.7 : 1, transition: 'opacity 0.2s',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4
                              }}>
                              💼 {isAdding ? 'Ajout...' : 'Ajouter au portefeuille'}
                            </button>
                          )}
                          {/* Contact button */}
                          {isContacted ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#F57F17', fontWeight: 600, flex: 1, justifyContent: 'center' }}>
                              <span>✉️</span> Contactée
                            </div>
                          ) : (
                            <button
                              onClick={() => setContactStartup(s)}
                              style={{
                                flex: 1, padding: '8px 10px', fontSize: 11, fontWeight: 600,
                                background: 'linear-gradient(135deg, var(--accent) 0%, #FF8F00 100%)',
                                color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4
                              }}>
                              ✉️ Contacter la startup
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )
        )}

        {tab === 'contacts' && (
          contacts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-light)' }}>
              <p>Aucune demande de contact envoyée</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: 12 }}>
              {contacts.map(c => (
                <div key={c.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <strong>{c.startup_name}</strong>
                    <span className="badge badge-secteur" style={{ marginLeft: 8 }}>{c.categorie}</span>
                    <div style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 4 }}>{c.message}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <span className="badge" style={{ background: c.status === 'pending' ? '#FFF3E0' : '#E8F5E9',
                      color: c.status === 'pending' ? '#E65100' : '#2E7D32' }}>
                      {c.status === 'pending' ? 'En attente' : c.status}
                    </span>
                    <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 4 }}>
                      {new Date(c.created_at).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>

      {/* Contact modal */}
      {contactStartup && (
        <ContactModal
          startup={contactStartup}
          onClose={() => setContactStartup(null)}
          onSent={load}
        />
      )}
    </div>
  );
}
